import React from 'react';
import {useTranslation} from 'react-i18next';
import ScaleFade from '../animations/ScaleFade';
import Spin from '../Spin';

/**
 * "Waiting for a response" indicator. Shared between the drawer/embedded
 * AgentChat and the full-width chat — each passes in its own styled
 * wrapper component so the visuals stay independent.
 *
 * `text` is what the agent says it is doing ("I'm retrieving expense data…"),
 * shown in place of "Wait a sec" while it streams progress.
 */
export const AgentChatWaitingIndicator = ({ WaitingSpace, type, text }) => {
  const [t] = useTranslation('main');
  return (
    <ScaleFade>
      <WaitingSpace direction='horizontal' size={4} type={type}>
        <Spin size='xxsmall' />
        <span>{text || `${t('waitASec')}...`}</span>
      </WaitingSpace>
    </ScaleFade>
  );
};
